import React, { useState } from 'react';
import MetricsTable from '@/pages/intelligence/pages/TopCharts/PCGames/MetricsTable';
// import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
// import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  TopchartPageId,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { useIntl } from 'umi';
import { PCConsoleSegementList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import {
  getStudioCompetitorTableDataRankList,
  getStudioCompetitorMetricsTableDataTrends,
} from '@intelligence/services/topcharts';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import moment from 'moment';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import { getDeviceValuesByPageId } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import {
  commonPCConsoleDefaultFilterValue,
  handleStudioCompetitorFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import useGSDOptions from '@intelligence/pages/TopCharts/_hooks/useGSDOptions';
import { getPCConsoleMetricValues } from '@intelligence/pages/TopCharts/PCGames/_config/utils';
import { defaultMetrictableApiParams } from '@intelligence/pages/TopCharts/PCGames/MetricsTable/utils/constant';
import type { pointInterId } from '@/pages/home/utils/buriedPoint';
import { SegmentOption } from '@intelligence/pages/PCConsoleBenchmark/types';
import { searchShortCutGames } from '@intelligence/services/filter';
import { JumpType } from '@home/utils/utils';

// 默认一页展示个数
const DEFAULT_PAGE_SIZE = 10;

interface IMetricsTableCompProps {
  // 默认勾选的游戏列表
  defaultSelection: object[];
  // 默认勾选的游戏id列表
  defaultSelectionIds: string[];
  // 高亮的游戏列表
  gameHightList: string[];
  pageLogMes: pointInterId;
  shortcutList: SegmentOption[];
  config?: {
    jumpType?: JumpType;
  };
}

// 非周粒度，隐藏2个GSD列
const NO_WEEK_HIDDEN_COLUMNS = ['gsd_digitalUnits', 'gsd_physicalUnits'];

export default function StudioCompetitor(props: IMetricsTableCompProps) {
  const {
    defaultSelectionIds,
    defaultSelection,
    gameHightList,
    pageLogMes,
    shortcutList,
    config,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const entityType = PC_CONSOLE_COMBINE_ENTITY_TYPE;
  // GSD device的options集合（级联）
  const { combineDevices: gsdDevices } = useGSDOptions();
  // pageId与Combine页面一至
  const pageId = TopchartPageId.PCConsoleMetricsTable;
  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.metricTable,
  });

  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.combileMetricTable?.type,
  });

  const { pcConsoleCascaderMetricsMap, pcConsoleDefaultMetrics } =
    PCConsoleSegementList;

  const [dataSourcesColumns, setDataSourcesColumns] = useState(
    pcConsoleDefaultMetrics?.map((item) => pcConsoleCascaderMetricsMap?.[item])?.filter(item => !NO_WEEK_HIDDEN_COLUMNS.includes(item.value)),
  );
  // 当前选中的快捷
  const [selectedShortcutActive, setSelectedShortcutActive] = useState<string[]>([shortcutList?.[0]?.value]);

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
    [filterKeyMap.RANGE_TIME]: {
      type: 'week',
      value: ['', ''],
    },
    [filterKeyMap.ALL_Games]: {
      value: defaultSelectionIds,
      keywords: '',
      isSearchAll: true,
      checkedList: defaultSelection,
    },
    [filterKeyMap.METRICTABLE_DEVICE]: {
      value: getDeviceValuesByPageId(pageId),
    },
  };

  const filterCfg: TopchartFilterCfgType = {
    filterKeyList: [
      filterKeyMap.RANGE_TIME,
      filterKeyMap.ALL_Games,
      filterKeyMap.REGION,
      filterKeyMap.METRICTABLE_DEVICE,
    ],
    companyFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
      [filterKeyMap.RANGE_TIME]: {
        type: 'month',
        value: [moment().subtract(6, 'months'), moment().subtract(1, 'months')],
      },
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: true,
      [filterKeyMap.METRICTABLE_DEVICE]: {
        btnName: 'dbi_platform',
      },
      [filterKeyMap.ALL_Games]: {
        selectGameBtnText: 'Competitor', // TODO翻译
        params: { entity_type: entityType, game_type: 'current_game', hasReleaseTime: false },
        chooseUpNum: 9,
        fixedSelectionGame: gameHightList,
        hasShortCut: true,
        shortcutList,
        onShortcutClick: (type: string, isActive: boolean) => {
          // 因多选数据会有问题，改成单选
          setSelectedShortcutActive(() => {
            if (isActive) {
              // 如果 isActive 为 true，将 type 添加到 selectedShortcutActive 中
              return [type];
            }
            // 如果 isActive 为 false，从 selectedShortcutActive 中移除 type
            return [];
          });
        },
        shortcutAddGame: false,
        selectedShortcutActive,
        searchAllGamesApi: searchShortCutGames,
        isShowShortcutTitle: false,
        notSelectTips: 'dbi_studio_competitor_game_selection_empty',
        transferModalClassName: 'dbh-studio-competitor-transfer-modal',
        setSelectedShortcutActive,
        shortCutNameEn: true,
      },
    },
    showConfirmButton: true,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: (params: any) =>
      handleStudioCompetitorFilterParamsToApi(params, entityType),
  };

  const orderMetricsParams = getPCConsoleMetricValues(
    pcConsoleDefaultMetrics.map((item) => pcConsoleCascaderMetricsMap?.[item]),
  );

  const defaultParams = {
    ...defaultMetrictableApiParams,
    entity_type: entityType,
    order_metric: orderMetricsParams?.order_metric,
    order_source: orderMetricsParams?.order_source,
    source_metrics: orderMetricsParams?.source_metrics,
    topchart_name: '',
    region_type: 'market',
    regions: ['global'],
    date_type: 'monthly',
    device: getDeviceValuesByPageId(pageId, entityType),
    page_size: DEFAULT_PAGE_SIZE,
    // 当选择的游戏ids为空时，传空字符串，无选择游戏获取无数据
    filter_ids: defaultSelectionIds?.length ? defaultSelectionIds : [''],
    // platforms: ["pc", "console"],
  };

  const onConfirm = (filterValue: any) => {
    let columns = pcConsoleDefaultMetrics.map((item) => pcConsoleCascaderMetricsMap?.[item]);
    if (filterValue?.date_type !== 'weekly') {
      columns = columns.filter(item => !NO_WEEK_HIDDEN_COLUMNS.includes(item.value));
    }
    setDataSourcesColumns(columns);
  };

  return (
    <MetricsTable
      entityType={entityType}
      pageId={pageId}
      pageLogInfo={pageLogMes}
      tableCloumsList={dataSourcesColumns}
      hasRegionFilter={true}
      cardMetricName={formatMessage({ id: 'dbi_label_metrics' })}
      // pcConsoleCascaderMetricsOptions={pcConsoleCascaderMetricsOptions}
      getTableApiFun={getStudioCompetitorTableDataRankList}
      getTrendApiFun={getStudioCompetitorMetricsTableDataTrends}
      filterCfg={filterCfg}
      filterLoading={filterLoading}
      isAllAndChecked={true}
      rangeTimeComponentDefault={latestTimeTypeHasData}
      gsdDevices={gsdDevices}
      defaultParams={defaultParams}
      sortByFront={true}
      hasSearch={false}
      defaultPageSize={DEFAULT_PAGE_SIZE}
      gameHightList={gameHightList}
      checkboxDisableTip={formatMessage({ id: 'dbi_cancel_prohibited' })}
      hasExtend={false}
      isStudio={true}
      visualLinkTable={true}
      tableLinkVisual={false}
      onConfirm={onConfirm}
      config={config}
    />
  );
}
